import {SelectOptionsChanged} from '../Form/SearchableSelects/Event';

const OTHER_OPTION_VALUE = '__custom__';

const SELECTOR_SELECT       = 'select[name="delimiter"]';
const SELECTOR_GROUP        = '[data-component="delimiter-group"]';
const SELECTOR_CUSTOM_INPUT = '[data-custom-delimiter]';

/** @param {SelectOptionsChanged} event */
document.addEventListener('selectoptionschanged', event => {
    const select = event.selectContainer.querySelector(SELECTOR_SELECT);

    if (!select) {
        return;
    }

    const group = select.closest(SELECTOR_GROUP);

    if (!group) {
        return;
    }

    const customInput = group.querySelector(SELECTOR_CUSTOM_INPUT);

    if (!customInput) {
        return;
    }

    if (select.value === OTHER_OPTION_VALUE) {
        customInput.removeAttribute('hidden');
        // Defer past od-select's own post-select this.focus(), which runs later in the same
        // call stack and would otherwise steal focus straight back off the revealed input.
        requestAnimationFrame(() => customInput.focus());
    } else {
        customInput.setAttribute('hidden', '');
        customInput.value = '';
    }
});
